import React from 'react';
import FadeInSection from './FadeInSection'; // Import the general animation wrapper

import './WelcomeSection.css';

const WelcomeSection = () => {

  
    const handleScrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };    


  return (
    <FadeInSection className="main-container">
      <h1 className="main-title">AI Agent Automation. Fast. Easy.</h1>
      {/* <h2 className="main-subtitle">Build AI That Improves Itself</h2> */}
      <p className="main-subtitle">
        AI agents are <strong>force multipliers</strong> - tireless team members powered by LLMs to make decisions and complete tasks.        
      </p>
     <p className="main-subtitle">
        Modlee accelerates your AI agent journey. Our <strong>foundational agents</strong> serve as both out-of-the-box solutions and scalable technology you can build upon.        
      </p>
      {/* <button className="main-button">→ Get started today</button> */}
      <button className="main-button" onClick={() => handleScrollToSection("get-started")}>
        → Amplify Your Effort Today
      </button>

    </FadeInSection>
  );
};

export default WelcomeSection;
